<template>
    <div>
        <Breadcrumbs title="Queue Report" />
        <div class="container-fluid">
            <div class="card p-4">
                <div>
                    <dataTableVue ref="refDataTable" :isExport="true" :isFilter="true" :renderMode="'csr'"
                        @load="loadItems" v-bind:data="{
                        columns: columns,
                        rows: rows,
                        exportDetail: exportDetail,
                        filter_custom: 'filterQueueReport',
                        rowCustom: 'rowQueueReport',
                        module: 'ccp'
                    }" />
                    <!-- @deleteRow="deleteRow" @editRow="editRow" @editToggle="editQue" @itemSelect="itemSelect" -->
                </div>
                <!-- // rowCustom: 'rowQueueManagement', -->
            </div>
        </div>
    </div>
</template>
<script>
import { requestService } from '../../../_services';
import moment from 'moment';

export default {
    data() {
        return {
            columns: [
                {
                    label: 'Date',
                    field: 'date',
                    hidden: false,
                },
                {
                    label: 'Queue name',
                    field: 'queue',
                    hidden: false,
                },
                {
                    label: 'Total',
                    field: 'count',
                    hidden: false,
                },
            ],
            rows: [
                // {
                //     date: '2024-04-26',
                //     name: 'test',
                //     type: 'type',
                //     count: 'amount'
                // }
            ],
            exportDetail: {
                fileName: 'export_queue_report',
                exportUrl: '',
            },
            startDate: '',
            endDate: '',
            allQueue: []
        };
    },

    async mounted() {
        await this.getQueue()
        // this.loadItems()
    },

    methods: {
        getQueue() {
            let url = `/api/mail/queue_management`;
            // ?page = ${ this.currentPage }& limit=${ this.perPage }
            requestService
                .GetFetch('ccp', url)
                .then((res) => {
                    if (res.status == 200) {
                        res.text().then(async (text) => {
                            const data = text && JSON.parse(text);
                            this.allQueue = await data.data
                            this.loadItems()
                        });
                    }
                }).catch((err) => {

                })
        },
        async loadItems(event) {
            this.rows = []
            // let queue = ''
            if (event != undefined) {
                this.startDate = event.filter.date_start
                this.endDate = event.filter.date_end
                // queue = event.filter.queue
            }
            let date = await this.formatDate()
            let start = date.date_start
            let end = date.date_end

            // let mockData = {
            //     "data": {
            //         "current_page": 1,
            //         "data": [
            //             {
            //                 "count": 251,
            //                 "date": "2024-05-29",
            //                 "queue": "65fd2e74004c9c0defa3846d"
            //             }
            //         ],
            //         "last_page": 1,
            //         "total": 1
            //     }
            // }

            // const mappedData = mockData.data.data.map(item => {
            //     const matchedQueue = this.allQueue.find(obj => obj._id === item.queue);
            //     return { ...item, queueName: matchedQueue.name };
            // });
            // this.rows = mappedData
            // console.log('mappedData: ', mappedData)
            // =========
            var str = '';
            if (event != undefined) {
                for (var key in event.params) {
                    if (str != '') {
                        str += '&';
                    }
                    str += key + '=' + encodeURIComponent(event.params[key]);
                }
                this.columns.forEach((element) => {
                    if (event.sortField == element.field) {
                        if (
                            event.sortField == 'created_at' ||
                            event.sortField == 'updated_at'
                        ) {
                            str += '&' + 'sortField=' + event.sortField;
                        } else {
                            str += '&' + 'sortField=' + element.field;
                        }
                    }
                });
                if (event.filter != undefined) {
                    for (var key in event.filter) {
                        if (str != '') {
                            str += '&';
                        }
                        if (key == 'date_start') {
                            str += key + '=' + start;
                        } else if (key == 'date_end') {
                            str += key + '=' + end;
                        } else {
                            str += key + '=' + encodeURIComponent(event.filter[key]);
                        }
                    }
                }
            }
            if (str == '') {
                str = `date_start=${start}&date_end=${end}&sortType=desc&sortField=created_at`;
            }
            // =========
            // console.log('str', str)

            // let str = `date_start=${start}&date_end=${end}&queue=${queue}`
            let url = '/api/mail/report/queue_daily/filter?' + str
            this.exportDetail.exportUrl = '/api/mail/report/queue_daily/export?' + str;
            requestService.GetFetch('ccp', url).then((res) => {
                if (res.status == 200) {
                    res.text().then((text) => {
                        const jsParse = text && JSON.parse(text);
                        const mappedData = jsParse.data.data.map(item => {
                            const matchedQueue = this.allQueue.find(obj => obj._id === item.queue);
                            return { ...item, queueName: matchedQueue.name };
                        });
                        this.rows = mappedData

                    });
                }
            }).catch((err) => {
                console.log('err: ', err)
            })
            // console.log('load')
        },

        formatDate() {
            let startDate = this.startDate;
            let endDate = this.endDate;
            const currentDate = new Date();

            // Determine the case based on the presence of startDate and endDate
            let caseType;
            if (!startDate && !endDate) {
                caseType = 'bothNull';
            } else if (!startDate) {
                caseType = 'startNull';
            } else if (!endDate) {
                caseType = 'endNull';
            } else {
                caseType = 'bothNotNull';
            }

            switch (caseType) {
                case 'bothNull':
                    startDate = moment(currentDate).startOf('day').format('YYYY-MM-DD HH:mm:ss');
                    endDate = moment(currentDate).endOf('day').format('YYYY-MM-DD HH:mm:ss');
                    break;
                case 'startNull':
                    const endDateMoment = moment(endDate);
                    const endDateMoment2 = moment(endDate);
                    startDate = endDateMoment.startOf('day').format('YYYY-MM-DD HH:mm:ss');
                    endDate = endDateMoment2.format('YYYY-MM-DD HH:mm:ss');
                    break;
                case 'endNull':
                    const startDateMoment = moment(startDate);
                    const startDateMoment2 = moment(startDate);
                    endDate = startDateMoment.endOf('day').format('YYYY-MM-DD HH:mm:ss');
                    startDate = startDateMoment2.format('YYYY-MM-DD HH:mm:ss');
                    break;
                case 'bothNotNull':
                    startDate = moment(startDate).format('YYYY-MM-DD HH:mm:ss');
                    endDate = moment(endDate).format('YYYY-MM-DD HH:mm:ss');
                    break;
                default:
                    break;
            }

            const object = {
                date_start: startDate,
                date_end: endDate,
            };

            return object;
        },
    },
};
</script>